<template>
  <v-card elevation="10">
    <v-toolbar color="red accent-2" dark>
      <v-toolbar-title> السلة </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <OrdersTable />
    <v-snackbar
      transition="fade-transition"
      v-model="snackbar"
      :timeout="timeout"
    >
      العدد يجب ان يكون اكبر من صفر
    </v-snackbar>
    <v-container>
      <v-row>
        <v-col offset="11">
          <v-btn @click="SubmitOrder" color="success">تأكيد الطلب</v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import OrdersTable from "../components/OrdersTable";

export default {
  data() {
    return {
      ListOfItems: [],
      timeout: 2500,
      snackbar: false,
    };
  },
  created() {
    this.GetItems();
  },
  components: {
    OrdersTable,
  },
  methods: {
    GetItems() {
      this.ListOfItems = this.$store.getters.CurrentCart;
      this.ListOfItems.forEach((element) => {
        element.qty = element.qty;
        element.name = element.name;
      });
    },
    SubmitOrder() {
      this.GetItems();
      let ThereisZero = false;
      this.ListOfItems.forEach((element) => {
        element.qty = parseInt(element.qty);
        if (element.qty < 0) ThereisZero = true;
      });

      if (ThereisZero) {
        this.snackbar = true;
      } else {
        const baseURI = "https://erp.matein3.com/api/Order/Create";
        this.$axios
          .post(baseURI, {
            items: this.ListOfItems,
          })
          .then((result) => {
            this.$store.dispatch("FlushCurrentCart");
            this.$router.push({ name: "Success" });
          });
      }
    },
    
  },
  
};
</script>

<style>
</style>